/**
 * Search Modal Component
 *
 */
class SearchModal extends HTMLElement {
  constructor() {
    super();

    let _this = this;
    this.openSearchModal = document.querySelectorAll('.open-searchform');
    this.searchFormContainer = this.querySelector('.searchform');
    this.searchresults = this.querySelector('.predictive-search');
    this.searchQuery = this.querySelector('form[action="/search"] [name="q"]');

    this.searchFormContainer.addEventListener('keyup', (event) => {
      event.code.toUpperCase() === 'ESCAPE' && this.close()
    });

    this.openSearchModal.forEach(toggleBtn =>{
      toggleBtn.addEventListener('click', function(event){
        _this.onToggleBtnClick(event);
      });
      toggleBtn.setAttribute('role', 'button');
      toggleBtn.setAttribute('aria-expanded', 'false');
    });
    
    const closeButton = this.querySelector('.search-modal__close-button');
    closeButton.addEventListener('click', this.close.bind(this));
    // ADA Compliance: Allow closing with Enter or Space key
    closeButton.addEventListener('keydown', (event) => {
      if (event.code === 'Enter' || event.code === 'Space') {
        event.preventDefault();
        this.close();
      }
    });

    this.typingTimer;
    this.searchQuery.addEventListener('input', this.queryInput.bind(this));
    this.searchQuery.addEventListener('keydown', () => {
      clearTimeout(this.typingTimer);
    });
  }

  /**
   * To check if search modal is open or closed
   * 
   * @returns {boolean} true/false
   */
  isOpen() {
    return this.searchFormContainer.hasAttribute('open');
  }

  /**
   * Toggle Search Modal on search Icon click
   *
   * @param {event} Event instance
   */
  onToggleBtnClick(event) {
    event.preventDefault();
    event.stopPropagation();
    if (this.searchFormContainer.hasAttribute('open')) {
      this.close();
    } else {
      // ADA: Store reference to the element that opened the modal
      this.openedBy = event.currentTarget;
      this.open(event);
    }
  }

  /**
   * Close Search Modal on body click if not within the Modal
   *
   * @param {event} Event instance
   */
  onBodyClick(event) {
    if (!this.contains(event.target)) this.close(false);
  }

  /**
   * lazyload the API call for fetch search suggestion on user Input
   *
   * @param {event} Event instance
   */
  queryInput(event){
    let _this = this;
    let inputEle = event.currentTarget;
    let queryValue = inputEle.value.trim();
    clearTimeout(_this.typingTimer);
    _this.typingTimer = setTimeout(function() {
      _this._queryChange(queryValue);
    }, 1000);
  }

  /**
   * lazyload the API call for fetch search suggestion on user Input
   *
   * @param {string} queryValue Search form query
   */
  _queryChange(queryValue){
    if(queryValue.length <= 0 || queryValue == null){
      return;
    }
    let searchType = this.searchFormContainer.querySelector('[name="type"]').value;
    fetch(`${routes.predictive_searh}?q=${queryValue}&resources[type]=${searchType}&resources[options][unavailable_products]=last`)
    .then(response => {
        return response.json();
      }).then(response => {
        const searchResults = response.resources.results;
        let productsList = '';
        if(searchResults.products.length > 0){
          searchResults.products.forEach((product) => {
            if (product.tags?.includes('hidden')) return;
            
            const productPrice = Shopify.formatMoney(product.price * 100, window.globalVariables.money_format);;
            let resultUI = `<div class="col-sm-6 px-2"><div class="predictive-search-product my-2 mx-n2 row">
                <div class="col-3 px-2">
                    <a href="${product.url}"><img src="${product.image}" alt="${product.title}"></a>
                </div>
                <div class="col-9 px-2">
                    <h6 class="product-title"><a href="${product.url}">${product.title}</a></h6>
                    <p class="product-price">${productPrice}</p>
                </div>
            </div></div>`;
            productsList += resultUI;
          });
          if(this.searchresults){
            this.searchresults.querySelector('.predictive-search-product-list').innerHTML = productsList;
            this.searchresults.querySelector('.predictive-search-footer a').href = `/search?q=${queryValue}&resources[type]=${searchType}`;
            this.searchresults.style.display = 'block';
          }
        }else{
          if(this.searchresults){
            this.searchresults.querySelector('.predictive-search-product-list').innerHTML = '';
            this.searchresults.style.display = 'none';
          }
        }
      }).catch((e) => {
        console.error(e);
      }).finally(() => {
        // Search JSON fetch done
      });
  }

  /**
   * Open Search Modal and add attributes, class and Events in DOM
   *
   * @param {event} Event instance
   */
  open(event) {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    this.searchFormContainer.setAttribute('open', true);
    siteOverlay.prototype.showOverlay();
    document.body.classList.add('search-open');
    //add class scrolled to site-header-wrapper
    const headerWrapper = document.querySelector('.site-header-wrapper');
    console.log('window.scrollY', window.scrollY);
    headerWrapper.classList.add('scrolled');
    this.classList.add('open__modal');
    this.removeAttribute('style');
    document.body.addEventListener('click', this.onBodyClickEvent);

    // ADA: Make all elements outside search modal inaccessible
    this.disableOutsideElements();

    // ADA: Focus input and set up focus trap
    const searchInput = document.getElementById('Search-In-Modal');
    
    // Focus input and set up focus trap after short delay for DOM readiness
    setTimeout(() => {
      if (searchInput) {
        searchInput.focus();
      }
      // Custom focus trap for entire search modal (includes results when they appear)
      this.setupSearchFocusTrap();
    }, 100);
  }

  /**
   * ADA: Set up focus trap within search modal
   * Dynamically finds focusable elements including search results
   */
  setupSearchFocusTrap() {
    this.focusTrapHandler = (event) => {
      if (event.key !== 'Tab') return;
      
      // Dynamically get all focusable elements (includes search results when visible)
      const focusableElements = this.getFocusableSearchElements();
      
      if (focusableElements.length === 0) return;
      
      const firstElement = focusableElements[0];
      const lastElement = focusableElements[focusableElements.length - 1];
      
      if (event.shiftKey) {
        // Shift + Tab: if on first element, go to last
        if (document.activeElement === firstElement) {
          event.preventDefault();
          lastElement.focus();
        }
      } else {
        // Tab: if on last element, go to first
        if (document.activeElement === lastElement) {
          event.preventDefault();
          firstElement.focus();
        }
      }
    };
    
    document.addEventListener('keydown', this.focusTrapHandler);
  }

  /**
   * ADA: Get all focusable elements within search modal
   * Includes search input, close button, and search result links
   */
  getFocusableSearchElements() {
    const elements = [];
    
    // 1. Search input
    const searchInput = this.querySelector('#Search-In-Modal');
    if (searchInput) elements.push(searchInput);
    
    // 2. Close button
    const closeButton = this.querySelector('.search-modal__close-button');
    if (closeButton) elements.push(closeButton);
    
    // 3. Search result links (only when visible)
    if (this.searchresults && this.searchresults.style.display !== 'none') {
      const resultLinks = this.searchresults.querySelectorAll('a[href]');
      resultLinks.forEach(link => elements.push(link));
    }
    
    return elements;
  }

  /**
   * Close Search Modal and remove attributes, class and Events in DOM
   *
   * @param {event} Event instance
   */
  close(focusToggle = true) {
    // ADA: Re-enable all elements outside search modal
    this.enableOutsideElements();
    
    // ADA: Remove focus trap handler
    if (this.focusTrapHandler) {
      document.removeEventListener('keydown', this.focusTrapHandler);
      this.focusTrapHandler = null;
    }

    Utility.removeTrapFocus();
    this.searchFormContainer.removeAttribute('open');
    
    // ADA: Return focus to the element that opened the modal (search icon)
    if (focusToggle && this.openedBy) {
      this.openedBy.focus();
      this.openedBy = null;
    }
    siteOverlay.prototype.hideOverlay();
    this.classList.remove('open__modal');
    document.body.classList.remove('search-open');
    const headerWrapper = document.querySelector('.site-header-wrapper');
    if ( window.scrollY > 0){
    }else {
      headerWrapper.classList.remove('scrolled');
    }
    document.body.removeEventListener('click', this.onBodyClickEvent);

    if(this.searchresults){
      this.searchresults.querySelector('.predictive-search-product-list').innerHTML = '';
      this.searchresults.style.display = 'none';
    }
  }

  /**
   * ADA: Disable all focusable elements outside the search modal
   * Makes elements inaccessible via Tab when search is open
   */
  disableOutsideElements() {
    // Store references to elements we're disabling
    this.disabledElements = [];
    
    // Get all siblings of the search-modal and main content areas
    const elementsToDisable = document.querySelectorAll(
      'header, main, footer, .site-header-wrapper, .shopify-section:not(.shopify-section--search-layer), nav, aside'
    );
    
    elementsToDisable.forEach(element => {
      // Don't disable if it's the search modal or contains it
      if (!element.contains(this) && element !== this) {
        element.setAttribute('inert', '');
        element.setAttribute('aria-hidden', 'true');
        this.disabledElements.push(element);
      }
    });
  }

  /**
   * ADA: Re-enable all focusable elements outside the search modal
   * Restores accessibility when search is closed
   */
  enableOutsideElements() {
    if (this.disabledElements && this.disabledElements.length > 0) {
      this.disabledElements.forEach(element => {
        element.removeAttribute('inert');
        element.removeAttribute('aria-hidden');
      });
      this.disabledElements = [];
    }
  }
}
customElements.define('search-modal', SearchModal);